export default __webpack_public_path__ + "static/media/vaibhav.048b6fd2.jpeg";